/**
 * Что видно в уведомлении посторонним.
 *
 * Уведомление приходит на экран блокировки — то есть на стол, на котором лежит
 * телефон, в руки соседа по вагону, на общий монитор во время созвона.
 * «Пора принять: Эутирокс» — это диагноз, прочитанный вслух: по названию
 * лекарства заболевание восстанавливается за одну секунду поиска.
 *
 * ## Почему по умолчанию скрыто
 *
 * Ошибиться можно в обе стороны, но цена разная. Не показали название —
 * человек открывает приложение и видит, какое лекарство: неудобство, которое
 * он замечает и может исправить одним переключателем. Показали — сведения о
 * здоровье прочитал посторонний, и человек об этом никогда не узнает.
 *
 * Так же поступает и «Здоровье» на iPhone: там напоминание говорит «пора
 * отметить лекарства», без названий.
 */

import { db } from '@/shared/db/database';

const namesKey = (userId: string) => `notifications.medicationNames:${userId}`;

/** Показывать ли название лекарства в уведомлении. */
export async function readShowMedicationNames(userId: string): Promise<boolean> {
  const row = await db.settings.get(namesKey(userId));
  // По умолчанию скрыто: см. рассуждение выше.
  return row?.value === true;
}

export async function setShowMedicationNames(userId: string, show: boolean): Promise<void> {
  await db.settings.put({ key: namesKey(userId), value: show, updatedAt: Date.now() });
}
